<app-about-hero></app-about-hero>
<app-investors></app-investors>
<app-customers></app-customers>
<app-team-overview></app-team-overview>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
